import { useDispatch, useSelector } from 'react-redux'

import { useCallback, useState } from 'react'
import { useInjectSaga, useInjectReducer } from '../store'
import courseListSaga from '../modules/course-list/store/saga'
import courseListReducer from '../modules/course-list/store/reducer'

import {
  loadCourseFree,
  loadCourseCompany,
  loadCourseCompanyNew,
  loadCourseCompanyRecommended,
  loadCourseCompanyRecentViews,
  loadCourseCost,
  loadCourseType,
  loadCourseNissoken,
  loadCourseNissokenNew,
  loadCourseNissokenRecommended,
  loadCourseNissokenRecentViews,
  loadChannelCounts,
  loadCourseNissokenByCategories,
  loadCourseCompanyByCategories,
  loadUncategorizedCourseNissoken,
  loadUncategorizedCourseCompany,
  changeCourseListTab,
  addToCart,
  removeFromCart,
  initCart,
  getCourseInCart,
  voteLikeCourseAction,
  searchingCourseList,
  updateSavedFilter,
  resetFilterCourseList,
  refreshCourseListPage,
  loadNewCourse,
  resetPageToInit,
  updateBookmarkRequest,
  updateViewedTab,
  resetViewedTab,
  updateViewedSearchResultTab,
  resetViewedSearchResultTab
} from '../modules/course-list/store/actions'
import {
  makeSelectCourseCompany,
  makeSelectCourseCompanyNew,
  makeSelectCourseCompanyRecommended,
  makeSelectCourseCompanyRecentViews,
  makeSelectCourseCost,
  makeSelectCourseFree,
  makeSelectCourseNissoken,
  makeSelectCourseNissokenNew,
  makeSelectCourseNissokenRecommended,
  makeSelectCourseNissokenRecentViews,
  makeSelectChannelCounts,
  makeSelectCoursesNissokenByCategories,
  makeSelectCoursesCompanyByCategories,
  makeSelectCourseUncategorizedNissoken,
  makeSelectCourseUncategorizedCompany,
  makeSelectCourseType,
  makeSelectcourseListTab,
  // makeSelectCourseInCart,
  makeSelectIsLiking,
  makeSelectSaveFilter,
  makeSelectIsSearching,
  makeSelectError,
  makeSelectViews,
  makeSelectNewCourse,
  makeSelectIsUpdatingBookmark,
  makeSelectViewedTab,
  makeSelectViewedSearchResultTab
} from '../modules/course-list/store/selectors'

import { ROUTES_NAME } from '../constants'

export const useCourseList = ({ userId }) => {
  useInjectSaga({ key: 'courseListStore', saga: courseListSaga })
  useInjectReducer({ key: 'courseListStore', reducer: courseListReducer })

  const dispatch = useDispatch()
  const { data: courseCompany, isLoading: courseCompanyIsLoading } = useSelector(makeSelectCourseCompany())
  const { data: courseCompanyNew, isLoading: courseCompanyNewIsLoading } = useSelector(makeSelectCourseCompanyNew())
  const { data: courseCompanyRecommended, isLoading: courseCompanyRecommendedIsLoading } = useSelector(makeSelectCourseCompanyRecommended())
  const { data: courseCompanyRecentViews, isLoading: courseCompanyRecentViewsIsLoading } = useSelector(makeSelectCourseCompanyRecentViews())
  const { data: courseCost, isLoading: courseCostIsLoading } = useSelector(makeSelectCourseCost())
  const { data: courseFree, isLoading: courseFreeIsLoading } = useSelector(makeSelectCourseFree())
  const { data: courseNissoken, isLoading: courseNissokenIsLoading } = useSelector(makeSelectCourseNissoken())
  const { data: courseNissokenNew, isLoading: courseNissokenNewIsLoading } = useSelector(makeSelectCourseNissokenNew())
  const { data: courseNissokenRecommended, isLoading: courseNissokenRecommendedIsLoading } = useSelector(makeSelectCourseNissokenRecommended())
  const { data: courseNissokenRecentViews, isLoading: courseNissokenRecentViewsIsLoading } = useSelector(makeSelectCourseNissokenRecentViews())
  const { data: coursesNew, isLoading: newCourseIsLoading } = useSelector(makeSelectNewCourse())
  const { data: channelCounts } = useSelector(makeSelectChannelCounts())

  const { data: courseType } = useSelector(makeSelectCourseType())
  // const { data: courseInCart } = useSelector(makeSelectCourseInCart())
  const courseListTab = useSelector(makeSelectcourseListTab())
  const isLiking = useSelector(makeSelectIsLiking())
  const isUpdatingBookmark = useSelector(makeSelectIsUpdatingBookmark())
  const isSearching = useSelector(makeSelectIsSearching())
  const error = useSelector(makeSelectError())
  const viewsCourseList = useSelector(makeSelectViews())
  const isCourseListPage = ROUTES_NAME.COURSE_LIST === window.location.pathname
  const isSearchResultPage = ROUTES_NAME.SEARCH_RESULT === window.location.pathname

  const getCourseCompany = (payload) => dispatch(loadCourseCompany(payload))
  const getCourseCompanyNew = (payload) => dispatch(loadCourseCompanyNew(payload))
  const getCourseCompanyRecommended = (payload) => dispatch(loadCourseCompanyRecommended(payload))
  const getCourseCompanyRecentViews = (payload) => dispatch(loadCourseCompanyRecentViews(payload))
  const getCourseNissoken = (payload) => dispatch(loadCourseNissoken(payload))
  const getCourseNissokenNew = (payload) => dispatch(loadCourseNissokenNew(payload))
  const getCourseNissokenRecommended = (payload) => dispatch(loadCourseNissokenRecommended(payload))
  const getCourseNissokenRecentViews = (payload) => dispatch(loadCourseNissokenRecentViews(payload))
  const getChannelCounts = (payload) => dispatch(loadChannelCounts(payload))
  const getCourseCost = (categories = [], courseSearch = '') => dispatch(loadCourseCost(categories, courseSearch))
  const getCourseFree = (categories = [], courseSearch = '') => dispatch(loadCourseFree(categories, courseSearch))
  const searchingCourseListAction = (payload) => dispatch(searchingCourseList(payload))
  const getCourseType = () => dispatch(loadCourseType(userId))
  const onChangeTab = (tab) => dispatch(changeCourseListTab(tab))
  const addCourseToCart = (course) => dispatch(addToCart(course))
  const getCourseDataInCart = () => dispatch(getCourseInCart())
  const removeCourseFromCart = (course) => dispatch(removeFromCart(course))
  const initCourseInCart = () => dispatch(initCart())
  const voteLikeCourse = (payload) => dispatch(voteLikeCourseAction(payload))
  const refreshCourseListPageAction = useCallback(() => dispatch(refreshCourseListPage()), [])
  const updateBookmarkAction = useCallback((payload) => dispatch(updateBookmarkRequest(payload)), [])

  const getNewCourse = (payload) => dispatch(loadNewCourse(payload))
  const resetPageToInitOfCourseListAction = useCallback(() => dispatch(resetPageToInit()), [])

  const getCourseNissokenByCategories = (payload) => dispatch(loadCourseNissokenByCategories(payload))
  const getCourseCompanyByCategories = (payload) => dispatch(loadCourseCompanyByCategories(payload))
  const { data: coursesNissokenByCategories, isLoading: coursesNissokenByCategoriesIsLoading } = useSelector(makeSelectCoursesNissokenByCategories())
  const { data: coursesCompanyByCategories, isLoading: coursesCompanyByCategoriesIsLoading } = useSelector(makeSelectCoursesCompanyByCategories())
  const [needsToLoadCompanyCategories, setNeedsToLoadCompanyCategories] = useState([])
  const [needsToLoadNissokenCategories, setNeedsToLoadNissokenCategories] = useState([])

  const getUncategorizedCourseNissoken = (payload) => dispatch(loadUncategorizedCourseNissoken(payload))
  const getUncategorizedCourseCompany = (payload) => dispatch(loadUncategorizedCourseCompany(payload))
  const { data: courseUncategorizedNissoken, isLoading: courseUncategorizedNissokenIsLoading } = useSelector(makeSelectCourseUncategorizedNissoken())
  const { data: courseUncategorizedCompany, isLoading: courseUncategorizedCompanyIsLoading } = useSelector(makeSelectCourseUncategorizedCompany())
  const [needsToLoadUncategorizedCompany, setNeedsToLoadUncategorizedCompany] = useState(true)
  const [needsToLoadUncategorizedNissoken, setNeedsToLoadUncategorizedNissoken] = useState(true)

  // Filter
  const savedFilter = useSelector(makeSelectSaveFilter())
  const updateSavedFilterAction = (payload) => dispatch(updateSavedFilter(payload))
  const resetFilterCourseListAction = () => {
    dispatch(resetFilterCourseList())
    resetPageToInitOfCourseListAction()
  }

  const viewedTab = useSelector(makeSelectViewedTab())
  const updateViewedTabAction = (payload) => dispatch(updateViewedTab(payload))
  const resetViewedTabAction = () => dispatch(resetViewedTab())

  const viewedSearchResultTab = useSelector(makeSelectViewedSearchResultTab())
  const updateViewedSearchResultTabAction = (payload) => dispatch(updateViewedSearchResultTab(payload))
  const resetViewedSearchResultTabAction = () => dispatch(resetViewedSearchResultTab())

  return {
    isLiking,
    isUpdatingBookmark,
    isSearching,
    courseCompany,
    courseCompanyNew,
    courseCompanyRecommended,
    courseCompanyRecentViews,
    courseCost,
    courseFree,
    courseNissoken,
    courseNissokenNew,
    courseNissokenRecommended,
    courseNissokenRecentViews,
    coursesNissokenByCategories,
    coursesCompanyByCategories,
    courseUncategorizedNissoken,
    courseUncategorizedCompany,
    courseType,
    courseListTab,
    // courseInCart,
    courseCompanyIsLoading,
    courseCompanyNewIsLoading,
    courseCompanyRecommendedIsLoading,
    courseCompanyRecentViewsIsLoading,
    courseCostIsLoading,
    courseFreeIsLoading,
    courseNissokenIsLoading,
    courseNissokenNewIsLoading,
    courseNissokenRecommendedIsLoading,
    courseNissokenRecentViewsIsLoading,
    coursesNissokenByCategoriesIsLoading,
    coursesCompanyByCategoriesIsLoading,
    courseUncategorizedNissokenIsLoading,
    courseUncategorizedCompanyIsLoading,
    channelCounts,
    error,
    viewsCourseList,
    getCourseCompany,
    getCourseCompanyNew,
    getCourseCompanyRecommended,
    getCourseCompanyRecentViews,
    getCourseCost,
    getCourseFree,
    getCourseNissoken,
    getCourseNissokenNew,
    getCourseNissokenRecommended,
    getCourseNissokenRecentViews,
    getChannelCounts,
    getCourseNissokenByCategories,
    getCourseCompanyByCategories,
    getUncategorizedCourseNissoken,
    getUncategorizedCourseCompany,
    getCourseType,
    onChangeTab,
    addCourseToCart,
    removeCourseFromCart,
    initCourseInCart,
    getCourseDataInCart,
    voteLikeCourse,
    searchingCourseListAction,
    refreshCourseListPageAction,
    getNewCourse,
    coursesNew,
    newCourseIsLoading,
    resetPageToInitOfCourseListAction,
    updateBookmarkAction,
    isCourseListPage,
    isSearchResultPage,
    updateViewedTabAction,
    resetViewedTabAction,
    viewedTab,
    resetViewedSearchResultTabAction,
    updateViewedSearchResultTabAction,
    viewedSearchResultTab,
    needsToLoadCompanyCategories,
    setNeedsToLoadCompanyCategories,
    needsToLoadNissokenCategories,
    setNeedsToLoadNissokenCategories,
    needsToLoadUncategorizedCompany,
    setNeedsToLoadUncategorizedCompany,
    needsToLoadUncategorizedNissoken,
    setNeedsToLoadUncategorizedNissoken,
    // filter
    savedFilter,
    updateSavedFilterAction,
    resetFilterCourseListAction
  }
}
